import { render } from "./registerCom.vue?vue&type=template&id=628c25ac&scoped=true"
import script from "./registerCom.vue?vue&type=script&lang=js"
export * from "./registerCom.vue?vue&type=script&lang=js"

import "./registerCom.vue?vue&type=style&index=0&id=628c25ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628c25ac"]])

export default __exports__